/**
 * b2b-modal.js
 * Controls the global B2B registration modal.
 *
 * Trigger: any element with [data-b2b-modal-trigger]
 * On pages with an inline form (#b2bInlineFormAnchor), scrolls to the form
 * instead of opening the modal.
 *
 * Features:
 *   - Slide-up panel animation (mobile sheet) / centered dialog (desktop)
 *   - Dirty-form confirmation when closing with unsaved input
 *   - ESC key + backdrop click to close
 *   - Resets form to step 1 on close
 */
(function () {
  'use strict';

  var isDE = (window.B2B_CONFIG && window.B2B_CONFIG.isDE) || false;

  var modal   = document.getElementById('b2bModal');
  var anchor  = document.getElementById('b2bInlineFormAnchor'); // present only on info page

  // If there is no modal in the DOM there is nothing to initialise.
  // (The modal is excluded from the info-page and registration-page templates.)
  if (!modal) return;

  var backdrop = modal.querySelector('.b2b-modal__backdrop');
  var panel    = modal.querySelector('.b2b-modal__panel');
  var closeBtn = document.getElementById('b2bModalClose');

  var isOpen = false;

  // ─── Helpers ────────────────────────────────────────────────────────────────

  /** Returns true if any text input / select inside the MODAL has a value. */
  function isDirty() {
    var fields = panel.querySelectorAll(
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="submit"]), select, textarea'
    );
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].value && fields[i].value.trim()) return true;
    }
    return false;
  }

  /** Resets the form inside the modal back to step 1. Scoped to the modal panel
   *  so it never touches a different b2b form instance on the same page. */
  function resetForm() {
    var form = panel.querySelector('[data-b2b-form]');
    if (form) form.reset();

    // Show form, hide success panel
    var success = panel.querySelector('[data-b2b-success]');
    if (success) success.style.display = 'none';
    if (form) form.style.display = '';

    // Activate step 1
    var steps = panel.querySelectorAll('.b2b-form-step');
    steps.forEach(function (s) {
      s.classList.toggle('active', s.dataset.step === '1');
    });

    // Reset step indicators
    var indicators = panel.querySelectorAll('.b2b-step-ind');
    indicators.forEach(function (ind) {
      ind.classList.remove('active', 'done');
      if (ind.dataset.step === '1') ind.classList.add('active');
    });

    // Hide VAT status and form errors
    var vatStatus = panel.querySelector('[data-b2b-vat-status]');
    if (vatStatus) vatStatus.style.display = 'none';
    var formError = panel.querySelector('[data-b2b-form-error]');
    if (formError) formError.style.display = 'none';

    // Hide shipping fields (reset to default "same as billing" state)
    var shippingFields = panel.querySelector('[data-b2b-shipping-fields]');
    if (shippingFields) shippingFields.style.display = 'none';
  }

  // ─── Open / Close ───────────────────────────────────────────────────────────

  function openModal() {
    if (isOpen) return;
    modal.removeAttribute('aria-hidden');
    modal.classList.add('is-open');
    document.body.classList.add('b2b-modal-open');
    isOpen = true;

    // Focus first visible input after transition
    setTimeout(function () {
      var first = panel.querySelector('input:not([type="hidden"]):not([type="checkbox"])');
      if (first) first.focus();
    }, 350);
  }

  function closeModal(skipDirtyCheck) {
    if (!isOpen) return;

    // Confirm if form has unsaved data
    if (!skipDirtyCheck && isDirty()) {
      var msg = isDE
        ? 'Formular schließen? Deine Eingaben gehen verloren.'
        : 'Close form? Your entered data will be lost.';
      if (!window.confirm(msg)) return;
    }

    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.classList.remove('b2b-modal-open');
    isOpen = false;

    // Reset after the close animation completes
    setTimeout(resetForm, 400);
  }

  // ─── Trigger handling ───────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-b2b-modal-trigger]');
    if (!trigger) return;
    e.preventDefault();

    // On the info page an inline anchor exists — scroll to it instead
    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Small offset for sticky headers
      setTimeout(function () {
        var y = anchor.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 50);
      return;
    }

    openModal();
  });

  // ─── Close events ───────────────────────────────────────────────────────────

  if (closeBtn) {
    closeBtn.addEventListener('click', function () { closeModal(false); });
  }

  if (backdrop) {
    backdrop.addEventListener('click', function () { closeModal(false); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeModal(false);
  });

  // After successful registration the success panel is shown; allow ESC to close
  // cleanly without a dirty check at that point — the success panel check
  // (isDirty reads only inputs, not the success div) already handles this.

})();
